import React, { useState, useEffect } from "react";
import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function Rough() {
  const [teachers, setTeachers] = useState([]);
  const [formData, setFormData] = useState({
    real_name: "",
    username: "",
    password: "",
    role: "",
    otherdata: "",
    validity: true,
  });
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });
  const [assignData, setAssignData] = useState({
    teacher: "",
    student: "",
  });

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCreateTeacher = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${baseURL}/createteacher/`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      alert("Teacher created successfully!");
      fetchTeachers();
    } catch (error) {
      alert("Error creating teacher: " + error.message);
    }
  };

  const fetchTeachers = async () => {
    try {
      const response = await axios.get(`${baseURL}/seeteachers/`);
      setTeachers(response.data.teachers || []);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  const handleTeacherLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(`${baseURL}/teacherloggingin/`, {
        params: loginData,
      });
      alert("Login successful!");
      console.log(response.data);
    } catch (error) {
      alert("Login failed: " + error.message);
    }
  };

  const handleAssignTeacher = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${baseURL}/assignteacher/`, assignData, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      alert("Teacher assigned successfully!");
    } catch (error) {
      alert("Error assigning teacher: " + error.message);
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, []);

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Teacher API Testing Interface</h2>

      {/* Create Teacher Form */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold mb-2">Create Teacher</h3>
        <form onSubmit={handleCreateTeacher} className="space-y-4">
          <input
            type="text"
            name="real_name"
            placeholder="Real Name"
            value={formData.real_name}
            onChange={handleFormChange}
            className="input"
          />
          <input
            type="text"
            name="username"
            placeholder="Username"
            value={formData.username}
            onChange={handleFormChange}
            className="input"
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleFormChange}
            className="input"
          />
          <input
            type="text"
            name="role"
            placeholder="Role"
            value={formData.role}
            onChange={handleFormChange}
            className="input"
          />
          <input
            type="text"
            name="otherdata"
            placeholder="Other Data"
            value={formData.otherdata}
            onChange={handleFormChange}
            className="input"
          />
          <label className="flex items-center">
            <input
              type="checkbox"
              name="validity"
              checked={formData.validity}
              onChange={handleFormChange}
              className="mr-2"
            />
            Validity
          </label>
          <button type="submit" className="btn">
            Create Teacher
          </button>
        </form>
      </div>

      {/* Teacher Login Form */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold mb-2">Teacher Login</h3>
        <form onSubmit={handleTeacherLogin} className="space-y-4">
          <input
            type="text"
            placeholder="Username"
            value={loginData.username}
            onChange={(e) =>
              setLoginData((prev) => ({ ...prev, username: e.target.value }))
            }
            className="input"
          />
          <input
            type="password"
            placeholder="Password"
            value={loginData.password}
            onChange={(e) =>
              setLoginData((prev) => ({ ...prev, password: e.target.value }))
            }
            className="input"
          />
          <button type="submit" className="btn">
            Login
          </button>
        </form>
      </div>

      {/* Assign Teacher Form */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold mb-2">
          Assign Teacher to Student
        </h3>
        <form onSubmit={handleAssignTeacher} className="space-y-4">
          <input
            type="number"
            placeholder="Teacher ID"
            value={assignData.teacher}
            onChange={(e) =>
              setAssignData((prev) => ({ ...prev, teacher: e.target.value }))
            }
            className="input"
          />
          <input
            type="number"
            placeholder="Student ID"
            value={assignData.student}
            onChange={(e) =>
              setAssignData((prev) => ({ ...prev, student: e.target.value }))
            }
            className="input"
          />
          <button type="submit" className="btn">
            Assign
          </button>
        </form>
      </div>

      {/* Display Teachers */}
      <div className="teacher-list">
        <h3 className="text-xl font-semibold mb-2">All Teachers</h3>
        <button onClick={fetchTeachers} className="btn mb-4">
          Refresh Teachers List
        </button>
        <div>
          {teachers.map((teacher, index) => (
            <div
              key={index}
              className="teacher-item bg-gray-100 p-4 mb-2 rounded"
            >
              <pre>{JSON.stringify(teacher, null, 2)}</pre>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
